<template>
  <div class="d-flex flex-center">
    <div
      class="card shadow col-12 col-sm-12 col-md-12 col-lg-12 col-xl-9 col-xxl-8"
      ref="errosGerais"
    >
      <div class="card-header">
        <h3 class="card-title" v-if="this.add">
          <img
            src="media/icons/duotune/general/gen055.svg"
            class="me-2"
          />Adicionar
        </h3>
        <h3 class="card-title" v-else>
          <img
            src="media/icons/duotune/general/gen055.svg"
            class="me-2"
          />Editar
        </h3>
        <div class="card-toolbar">
          <router-link
            to="/configuracoes/usuarios/consultar"
            class="btn btn-sm btn-light"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
            </span>
            Voltar
          </router-link>
        </div>
      </div>
      <div class="card-body p-5">
        <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
          <span class="indicator-progress">
            Aguarde, carregando...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </div>
        <div
          v-if="this.errosGerais.Message"
          class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
        >
          <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
            <inline-svg src="media/icons/duotune/general/gen044.svg" />
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <h4 class="text-gray-800 fw-bolder">Aviso</h4>
              <div class="fs-6 text-gray-600">
                {{ this.errosGerais.Message }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="this.errosValidacaoGeral.length && !this.loading"
          class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-7 me-7 mb-9 p-6"
        >
          <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
            <inline-svg src="media/icons/duotune/general/gen044.svg" />
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <h4 class="text-gray-800 fw-bolder">Aviso</h4>
              <div class="fs-6 text-gray-600">
                <ul>
                  <li v-for="value in this.errosValidacaoGeral" :key="value">
                    {{ value }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!loading">
          <div v-if="add" class="card shadow mb-5 mb-xl-10">
            <div
              ref="usuario_login"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_login"
              aria-expanded="true"
              aria-controls="usuario_login"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Login</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_login" class="collapse show">
              <div>
                <div class="card-body border-top p-9">
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Nome</label
                    >
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        class="form-control"
                        v-model="usuario.nome"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["nome"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Email</label
                    >
                    <div class="col-lg-8 fv-row">
                      <div class="input-group">
                        <span class="input-group-text" id="basic-addon3">
                          <i class="bi bi-at fs-3"></i>
                        </span>
                        <input
                          type="email"
                          class="form-control"
                          v-model="usuario.usuario"
                        />
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["usuario"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Senha</label
                    >
                    <div class="col-lg-8 fv-row">
                      <div class="input-group">
                        <span class="input-group-text" id="basic-addon3">
                          <i class="bi bi-key fs-3"></i>
                        </span>
                        <input
                          type="password"
                          class="form-control"
                          v-model="usuario.senha"
                        />
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["senha"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="row mb-6"
                    v-if="this.user.User.TipoUsuario.tipo === 'Administrador'"
                  >
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Permissões Administrativas</label
                    >
                    <div class="col-lg-8 fv-row">
                      <select
                        class="form-select"
                        v-model="usuario.id_tipo_usuario"
                      >
                        <option
                          v-for="tipo in tiposUsuarios"
                          v-bind:key="tipo.id"
                          v-bind:value="tipo.id"
                        >
                          {{ tipo.tipo }}
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_tipo_usuario"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Permissões de Usuários</label
                    >
                    <div class="col-lg-8 fv-row">
                      <select
                        class="form-select"
                        v-model="usuario.id_emitente_tipo_usuario"
                      >
                        <option
                          v-for="tipo in emitenteTiposUsuarios"
                          v-bind:key="tipo.id"
                          v-bind:value="tipo.id"
                        >
                          {{ tipo.tipo }}
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_emitente_tipo_usuario"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card shadow mb-5 mb-xl-10">
            <div
              ref="usuario_perfil"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_perfil"
              aria-expanded="true"
              aria-controls="usuario_perfil"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Perfil</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_perfil" class="collapse show">
              <div v-if="!loadingPerfil">
                <div class="card-body border-top p-9">
                  <div
                    v-if="this.errosGeraisPerfil.Message"
                    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                        <div class="fs-6 text-gray-600">
                          {{ this.errosGeraisPerfil.Message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label fw-bold fs-6"
                      >Foto</label
                    >
                    <div class="col-lg-8">
                      <div
                        id="imgFoto"
                        class="image-input image-input-outline"
                        data-kt-image-input="true"
                      >
                        <div
                          class="image-input-wrapper imagePreviewWrapper w-125px h-125px"
                          v-if="usuario.UsuarioDado && usuario.UsuarioDado.foto"
                          :style="{
                            'background-image': `url(${usuario.UsuarioDado.foto})`,
                          }"
                        ></div>
                        <div
                          class="image-input-wrapper imagePreviewWrapper w-125px h-125px"
                          v-else
                          :style="{
                            'background-image': `url(media/svg/avatars/blank.svg)`,
                          }"
                        ></div>
                        <label
                          class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                          data-kt-image-input-action="change"
                          data-bs-toggle="tooltip"
                          data-bs-dismiss="click"
                          title="Alterar foto"
                        >
                          <i class="bi bi-pencil-fill fs-7"></i>
                          <input
                            ref="fileInput"
                            type="file"
                            name="avatar"
                            accept=".png, .jpg, .jpeg"
                            @input="pickFile"
                          />
                          <input type="hidden" name="avatar_remove" />
                        </label>
                        <span
                          class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                          data-kt-image-input-action="remove"
                          data-bs-toggle="tooltip"
                          @click="removerFoto()"
                          data-bs-dismiss="click"
                          title="Remover foto"
                        >
                          <i class="bi bi-x fs-2"></i>
                        </span>
                      </div>
                      <div class="form-text mt-4">
                        Tipo de arquivos aceitos: .png, .jpg, .jpeg.
                      </div>
                    </div>
                  </div>
                  <div v-if="add == false" class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Nome</label
                    >
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        class="form-control"
                        v-model="usuario.nome"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacaoPerfil["nome"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >CPF / CNPJ</label
                    >
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        class="form-control"
                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                        v-model="usuario.UsuarioDado.cpf_cnpj"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioDadocpf_cnpj"] }}
                        {{ errosValidacaoPerfil["cpf_cnpj"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label fw-bold fs-6"
                      >RG / IE</label
                    >
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        class="form-control"
                        v-model="usuario.UsuarioDado.rg_ie"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioDadorg_ie"] }}
                        {{ errosValidacaoPerfil["rg_ie"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label fw-bold fs-6"
                      >Contato</label
                    >
                    <div class="col-lg-8 fv-row">
                      <input
                        type="text"
                        class="form-control"
                        v-model="usuario.UsuarioDado.contato"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioDadocontato"] }}
                        {{ errosValidacaoPerfil["contato"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-0">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Tipo</label
                    >
                    <div class="col-lg-8 fv-row">
                      <select
                        class="form-select"
                        v-model="usuario.UsuarioDado.tipo"
                      >
                        <option value="F">Física</option>
                        <option value="J">Jurídica</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioDadotipo"] }}
                        {{ errosValidacaoPerfil["tipo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      add == false &&
                      this.user.User.TipoUsuario.tipo === 'Administrador'
                    "
                    class="row mt-6 mb-0"
                  >
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Permissões Administrativas</label
                    >
                    <div class="col-lg-8 fv-row">
                      <select
                        class="form-select"
                        v-model="usuario.id_tipo_usuario"
                      >
                        <option
                          v-for="tipo in tiposUsuarios"
                          v-bind:key="tipo.id"
                          v-bind:value="tipo.id"
                        >
                          {{ tipo.tipo }}
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacaoPerfil["id_tipo_usuario"] }}
                      </div>
                    </div>
                  </div>
                  <div v-if="add == false" class="row mt-6 mb-6">
                    <label class="col-lg-4 col-form-label required fw-bold fs-6"
                      >Permissões de Usuários</label
                    >
                    <div class="col-lg-8 fv-row">
                      <select
                        class="form-select"
                        v-model="usuario.id_emitente_tipo_usuario"
                      >
                        <option
                          v-for="tipo in emitenteTiposUsuarios"
                          v-bind:key="tipo.id"
                          v-bind:value="tipo.id"
                        >
                          {{ tipo.tipo }}
                        </option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacaoPerfil["id_emitente_tipo_usuario"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-6">
                    <label class="col-lg-4 col-form-label fw-bold fs-6"
                      >Assistente de boas vindas</label
                    >
                    <div class="col-lg-8 d-flex align-items-center">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexSwitchChecked"
                          v-model="usuario.assistente_boas_vindas"
                        />
                        <label
                          class="form-check-label fw-bold"
                          for="flexSwitchChecked"
                        ></label>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["assistente_boas_vindas"] }}
                      </div>
                    </div>
                  </div>
                  <div class="row mb-0">
                    <label class="col-lg-4 col-form-label fw-bold fs-6"
                      >Ativo</label
                    >
                    <div class="col-lg-8 d-flex align-items-center">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexSwitchChecked"
                          v-model="usuario.ativo"
                        />
                        <label
                          class="form-check-label"
                          for="flexSwitchChecked"
                        ></label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top p-9">
                  <div v-bind:data-kt-indicator="loadingPerfil ? 'on' : 'off'">
                    <span class="indicator-progress">
                      Aguarde, carregando...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="add == false"
                class="card-footer d-flex justify-content-end py-6 px-9"
              >
                <button
                  @click="limparPerfil()"
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Descartar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarPerfil()"
                  v-bind:data-kt-indicator="this.loadingPerfil ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span class="svg-icon svg-icon-1" v-if="!this.loadingPerfil">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Salvar
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="
              (this.add === false && this.consultarUsuarioTelefone) || this.add
            "
            class="card shadow mb-5 mb-xl-10"
          >
            <div
              ref="usuario_telefone"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_telefone"
              aria-expanded="true"
              aria-controls="usuario_telefone"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Telefones</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_telefone" class="collapse show">
              <div v-if="!loadingTelefone">
                <div class="card-body border-top p-9">
                  <div
                    v-if="this.errosGeraisTelefone.Message"
                    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                        <div class="fs-6 text-gray-600">
                          {{ this.errosGeraisTelefone.Message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row mb-6"
                    v-for="(telefone, i) in this.usuario.UsuarioTelefone"
                    v-bind:key="i"
                  >
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Descrição</label
                      >
                      <select
                        class="form-select"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioTelefone === false
                        "
                      >
                        <option value="Celular">Celular</option>
                        <option value="Telefone">Telefone</option>
                        <option value="Casa">Casa</option>
                        <option value="Comercial">Comercial</option>
                        <option value="Fax Residencial">Fax Residencial</option>
                        <option value="Fax Comercial">Fax Comercial</option>
                        <option value="Outro">Outro</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioTelefone[" + i + "]descricao"]
                        }}
                        {{
                          errosValidacaoTelefone[i]
                            ? errosValidacaoTelefone[i]["descricao"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Número</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        v-model="telefone.telefone"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioTelefone === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioTelefone[" + i + "]telefone"]
                        }}
                        {{
                          errosValidacaoTelefone[i]
                            ? errosValidacaoTelefone[i]["telefone"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 d-flex align-self-end fv-row mb-6">
                      <button
                        v-if="this.excluirUsuarioTelefone"
                        @click="excluirTelefone(i)"
                        class="btn btn-light-danger svg-icon-white me-2 mb-2"
                      >
                        <i class="la la-trash-o me-2 fs-3"></i>Excluír
                      </button>
                    </div>
                  </div>
                  <div class="form-group mt-5">
                    <button
                      v-if="this.adicionarUsuarioTelefone"
                      @click="adicionarTelefone()"
                      class="btn btn-light-primary"
                    >
                      <i class="la la-plus me-2 fs-3"></i>Adicionar
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top p-9">
                  <div
                    v-bind:data-kt-indicator="loadingTelefone ? 'on' : 'off'"
                  >
                    <span class="indicator-progress">
                      Aguarde, carregando...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="add == false"
                class="card-footer d-flex justify-content-end py-6 px-9"
              >
                <button
                  @click="limparTelefone()"
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Descartar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarTelefone()"
                  v-bind:data-kt-indicator="this.loadingTelefone ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span
                    class="svg-icon svg-icon-1"
                    v-if="!this.loadingTelefone"
                  >
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Salvar
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="
              (this.add === false && this.consultarUsuarioEndereco) || this.add
            "
            class="card shadow mb-0 mb-xl-5"
          >
            <div
              ref="usuario_endereco"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_endereco"
              aria-expanded="true"
              aria-controls="usuario_endereco"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Endereços</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_endereco" class="collapse show">
              <div v-if="!loadingEndereco">
                <div class="card-body border-top p-9">
                  <div
                    v-if="this.errosGeraisEndereco.Message"
                    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                        <div class="fs-6 text-gray-600">
                          {{ this.errosGeraisEndereco.Message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row mb-6"
                    v-for="(endereco, i) in this.usuario.UsuarioEndereco"
                    v-bind:key="i"
                  >
                    <div
                      v-if="i != 0"
                      class="separator border-2 separator-dashed border-gray-300 mb-10"
                    ></div>
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Descrição</label
                      >
                      <select
                        class="form-select"
                        v-model="endereco.descricao"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      >
                        <option value="Casa">Casa</option>
                        <option value="Trabalho">Trabalho</option>
                        <option value="Comercial">Comercial</option>
                        <option value="Outro">Outro</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioEndereco[" + i + "]descricao"]
                        }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["descricao"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >CEP</label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          @keydown.stop.prevent.enter="pesquisarCep(i)"
                          class="form-control"
                          v-mask="'#####-###'"
                          v-model="endereco.cep"
                          :disabled="
                            this.add === false &&
                            this.editarUsuarioEndereco === false
                          "
                        />
                        <button
                          @click="pesquisarCep(i)"
                          class="input-group-text"
                          v-bind:data-kt-indicator="loadingCep ? 'on' : 'off'"
                        >
                          <span class="svg-icon svg-icon-2" v-if="!loadingCep">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                          <span class="indicator-progress">
                            <span
                              class="spinner-border align-middle"
                              style="width: 1.5rem; height: 1.5rem"
                            ></span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]cep"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["cep"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-8 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Endereço</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.endereco"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioEndereco[" + i + "]endereco"]
                        }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["endereco"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Número</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.numero"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]numero"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["numero"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-6 fv-row mb-6">
                      <label class="form-label fw-bold fs-6">Complemento</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.complemento"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao[
                            "UsuarioEndereco[" + i + "]complemento"
                          ]
                        }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["complemento"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-6 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Bairro</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.bairro"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]bairro"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["bairro"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6">UF</label>
                      <select
                        class="form-select"
                        v-model="endereco.uf"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      >
                        <option value="AC">Acre</option>
                        <option value="AL">Alagoas</option>
                        <option value="AP">Amapá</option>
                        <option value="AM">Amazonas</option>
                        <option value="BA">Bahia</option>
                        <option value="CE">Ceara</option>
                        <option value="DF">Distrito Federal</option>
                        <option value="ES">Espirito Santo</option>
                        <option value="GO">Goiás</option>
                        <option value="MA">Maranhão</option>
                        <option value="MT">Mato Grosso</option>
                        <option value="MS">Mato Grosso do Sul</option>
                        <option value="MG">Minas Gerais</option>
                        <option value="PA">Para</option>
                        <option value="PB">Paraíba</option>
                        <option value="PR">Paraná</option>
                        <option value="PE">Pernambuco</option>
                        <option value="PI">Piauí</option>
                        <option value="RJ">Rio de Janeiro</option>
                        <option value="RN">Rio Grande do Norte</option>
                        <option value="RS">Rio Grande do Sul</option>
                        <option value="RO">Rondônia</option>
                        <option value="RR">Roraima</option>
                        <option value="SC">Santa Catarina</option>
                        <option value="SP">São Paulo</option>
                        <option value="SE">Sergipe</option>
                        <option value="TO">Tocantins</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]uf"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["uf"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-5 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >Cidade</label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :value="
                            endereco.cidade ? endereco.cidade.toUpperCase() : ''
                          "
                          @input="
                            endereco.cidade = $event.target.value.toUpperCase()
                          "
                          :disabled="
                            this.add === false &&
                            this.editarUsuarioEndereco === false
                          "
                        />
                        <button
                          class="input-group-text"
                          @click="exibirModalCidades(true, i)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]cidade"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["cidade"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-3 fv-row mb-6">
                      <label class="form-label required fw-bold fs-6"
                        >País</label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          :value="
                            endereco.pais ? endereco.pais.toUpperCase() : ''
                          "
                          @input="
                            endereco.pais = $event.target.value.toUpperCase()
                          "
                          :disabled="
                            this.add === false &&
                            this.editarUsuarioEndereco === false
                          "
                        />
                        <button
                          class="input-group-text"
                          @click="exibirModalPaises(true, i)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["UsuarioEndereco[" + i + "]pais"] }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["pais"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-3 fv-row mb-6">
                      <label class="form-label fw-bold fs-6">Latitude</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.latitude"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioEndereco[" + i + "]latitude"]
                        }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["latitude"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-3 fv-row mb-6">
                      <label class="form-label fw-bold fs-6">Longitude</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="endereco.longitude"
                        :disabled="
                          this.add === false &&
                          this.editarUsuarioEndereco === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["UsuarioEndereco[" + i + "]longitude"]
                        }}
                        {{
                          errosValidacaoEndereco[i]
                            ? errosValidacaoEndereco[i]["longitude"]
                            : ""
                        }}
                      </div>
                    </div>
                    <div class="col-md-4 d-flex align-self-end fv-row mb-6">
                      <button
                        v-if="this.excluirUsuarioEndereco"
                        @click="excluirEndereco(i)"
                        class="btn btn-light-danger svg-icon-white me-2 mb-2"
                      >
                        <i class="la la-trash-o me-2 fs-3"></i>Excluír
                      </button>
                    </div>
                  </div>
                  <div class="form-group mt-5">
                    <button
                      v-if="this.adicionarUsuarioEndereco"
                      @click="adicionarEndereco()"
                      class="btn btn-light-primary"
                    >
                      <i class="la la-plus me-2 fs-3"></i>Adicionar
                    </button>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top p-9">
                  <div
                    v-bind:data-kt-indicator="loadingEndereco ? 'on' : 'off'"
                  >
                    <span class="indicator-progress">
                      Aguarde, carregando...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="add == false"
                class="card-footer d-flex justify-content-end py-6 px-9"
              >
                <button
                  @click="limparEndereco()"
                  class="btn btn-danger svg-icon-white me-2 mb-2"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg
                      src="media/icons/duotune/arrows/arr015.svg"
                      class="me-2"
                    />Descartar
                  </span>
                </button>
                <button
                  class="btn btn-success svg-icon-white mb-2"
                  @click="confirmarEndereco()"
                  v-bind:data-kt-indicator="this.loadingEndereco ? 'on' : 'off'"
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span
                    class="svg-icon svg-icon-1"
                    v-if="!this.loadingEndereco"
                  >
                    <inline-svg
                      src="media/icons/duotune/arrows/arr016.svg"
                      class="me-2"
                    />Salvar
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="add == false"
            class="card shadow mt-5 mt-xl-10 mb-5 mb-xl-10"
          >
            <div
              ref="usuario_metodo_login"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_metodo_login"
              aria-expanded="true"
              aria-controls="usuario_metodo_login"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Método de Login</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_metodo_login" class="collapse show">
              <div v-if="!loadingMetodoLogin">
                <div class="card-body border-top p-9">
                  <div
                    v-if="this.errosGeraisMetodoLogin.Message"
                    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                        <div class="fs-6 text-gray-600">
                          {{ this.errosGeraisMetodoLogin.Message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap align-items-center mb-8">
                    <div :class="{ 'd-none': emailExibir }">
                      <div class="fs-4 fw-boldest mb-1">Email</div>
                      <div class="fs-6 fw-bold text-gray-600">
                        {{ usuario.usuario }}
                      </div>
                    </div>
                    <div :class="{ 'd-none': emailExibir }" class="ms-auto">
                      <button
                        class="btn btn-light fw-boldest px-6"
                        @click="exibirEmail()"
                      >
                        Alterar Email
                      </button>
                    </div>
                    <div
                      :class="{ 'd-none': !emailExibir }"
                      class="flex-row-fluid"
                    >
                      <div>
                        <div class="row">
                          <div class="col-md-6 fv-row mb-6">
                            <label class="form-label required fw-bold fs-6"
                              >Digite o novo endereço de email</label
                            >
                            <input
                              type="email"
                              class="form-control"
                              v-model="usuario.usuario"
                            />
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacaoMetodoLogin["usuario"] }}
                            </div>
                          </div>
                          <div class="col-md-6 fv-row mb-6">
                            <label class="form-label required fw-bold fs-6"
                              >Confirme sua senha</label
                            >
                            <input
                              type="password"
                              class="form-control"
                              v-model="senhaAtual"
                            />
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacaoMetodoLogin["senhaAtual"] }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-end">
                          <button
                            @click="limparEmail()"
                            class="btn btn-danger svg-icon-white me-2 mb-2"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr015.svg"
                                class="me-2"
                              />Descartar
                            </span>
                          </button>
                          <button
                            class="btn btn-success svg-icon-white mb-2"
                            @click="confirmarEmail()"
                            v-bind:data-kt-indicator="
                              this.loadingMetodoLogin ? 'on' : 'off'
                            "
                          >
                            <span class="indicator-progress">
                              <span
                                class="spinner-border spinner-border-sm align-middle ms-1"
                              ></span>
                              Aguarde...
                            </span>
                            <span
                              class="svg-icon svg-icon-1"
                              v-if="!this.loadingMetodoLogin"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr016.svg"
                                class="me-2"
                              />Salvar
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-wrap align-items-center mb-8">
                    <div :class="{ 'd-none': senhaExibir }">
                      <div class="fs-4 fw-boldest mb-1">Senha</div>
                      <div class="fs-6 fw-bold text-gray-600">**********</div>
                    </div>
                    <div class="ms-auto" :class="{ 'd-none': senhaExibir }">
                      <button
                        @click="exibirSenha()"
                        class="btn btn-light fw-boldest"
                      >
                        Alterar Senha
                      </button>
                    </div>
                    <div
                      class="flex-row-fluid"
                      :class="{ 'd-none': !senhaExibir }"
                    >
                      <div>
                        <div class="row">
                          <div class="col-md-4 fv-row mb-6">
                            <label class="form-label required fw-bold fs-6">
                              Senha Atual</label
                            >
                            <input
                              type="password"
                              class="form-control"
                              v-model="senhaAtual"
                            />
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacaoMetodoLogin["senhaAtual"] }}
                            </div>
                          </div>
                          <div class="col-md-4 fv-row mb-6">
                            <label class="form-label required fw-bold fs-6">
                              Nova Senha</label
                            >
                            <input
                              type="password"
                              class="form-control"
                              v-model="novaSenha"
                            />
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacaoMetodoLogin["novaSenha"] }}
                              {{ errosValidacaoMetodoLogin["senha"] }}
                            </div>
                          </div>
                          <div class="col-md-4 fv-row mb-6">
                            <label class="form-label required fw-bold fs-6"
                              >Confirme sua nova senha</label
                            >
                            <input
                              type="password"
                              class="form-control"
                              v-model="confirmarNovaSenha"
                            />
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacaoMetodoLogin["confirmarNovaSenha"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-end">
                          <button
                            @click="limparSenha()"
                            class="btn btn-danger svg-icon-white me-2 mb-2"
                          >
                            <span class="svg-icon svg-icon-1">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr015.svg"
                                class="me-2"
                              />Descartar
                            </span>
                          </button>
                          <button
                            class="btn btn-success svg-icon-white mb-2"
                            @click="confirmarSenha()"
                            v-bind:data-kt-indicator="
                              this.loadingMetodoLogin ? 'on' : 'off'
                            "
                          >
                            <span class="indicator-progress">
                              <span
                                class="spinner-border spinner-border-sm align-middle ms-1"
                              ></span>
                              Aguarde...
                            </span>
                            <span
                              class="svg-icon svg-icon-1"
                              v-if="!this.loadingMetodoLogin"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr016.svg"
                                class="me-2"
                              />Salvar
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top p-9">
                  <div
                    v-bind:data-kt-indicator="loadingMetodoLogin ? 'on' : 'off'"
                  >
                    <span class="indicator-progress">
                      Aguarde, carregando...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="add == false"
            class="card shadow mt-5 mt-xl-10 mb-0 mb-xl-5"
          >
            <div
              ref="usuario_desativar"
              class="card-header collapsible border-0"
              role="button"
              data-bs-toggle="collapse"
              data-bs-target="#usuario_desativar"
              aria-expanded="true"
              aria-controls="usuario_desativar"
            >
              <div class="card-title m-0">
                <h3 class="fw-bolder m-0">Desativar Conta</h3>
              </div>
              <div class="card-toolbar rotate-180">
                <span class="svg-icon svg-icon-1"
                  ><inline-svg src="media/icons/duotune/arrows/arr082.svg"
                /></span>
              </div>
            </div>
            <div id="usuario_desativar" class="collapse show">
              <div v-if="!loadingDesativar">
                <div class="card-body border-top p-9">
                  <div
                    v-if="this.errosGeraisDesativar.Message"
                    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                        <div class="fs-6 text-gray-600">
                          {{ this.errosGeraisDesativar.Message }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6"
                  >
                    <span class="svg-icon svg-icon-2tx svg-icon-warning me-4">
                      <inline-svg
                        src="media/icons/duotune/general/gen044.svg"
                      />
                    </span>
                    <div class="d-flex flex-stack flex-grow-1">
                      <div class="fw-bold">
                        <h4 class="text-gray-800 fw-bolder">
                          Você está desativando sua conta!
                        </h4>
                        <div class="fs-6 text-gray-600">
                          Se tiver certeza de que deseja desativar sua conta, é
                          necessário que você confirme o checkbox abaixo.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-check form-check-solid fv-row">
                    <label
                      class="form-check-label fw-bold ps-2 fs-6"
                      for="desativar"
                      >Confirmar desativação da conta</label
                    >
                    <input
                      id="desativar"
                      class="form-check-input"
                      type="checkbox"
                      v-model="desativar"
                    />
                    <div class="fv-plugins-message-container invalid-feedback">
                      {{ errosValidacaoDesativar }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="card-body border-top p-9">
                  <div
                    v-bind:data-kt-indicator="loadingDesativar ? 'on' : 'off'"
                  >
                    <span class="indicator-progress">
                      Aguarde, carregando...
                      <span
                        class="spinner-border spinner-border-sm align-middle ms-2"
                      ></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end py-6 px-9">
                <button
                  class="btn btn-danger svg-icon-white mb-2"
                  @click="desativarUsuario()"
                  v-bind:data-kt-indicator="
                    this.loadingDesativar ? 'on' : 'off'
                  "
                >
                  <span class="indicator-progress">
                    <span
                      class="spinner-border spinner-border-sm align-middle ms-1"
                    ></span>
                    Aguarde...
                  </span>
                  <span
                    class="svg-icon svg-icon-1"
                    v-if="!this.loadingDesativar"
                  >
                    Desativar Conta
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="add" class="card-footer d-flex justify-content-end py-6 px-9">
        <router-link
          to="/configuracoes/usuarios/consultar"
          class="btn btn-danger svg-icon-white me-2 mb-2"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg
              src="media/icons/duotune/arrows/arr015.svg"
              class="me-2"
            />Cancelar
          </span>
        </router-link>
        <button
          class="btn btn-success svg-icon-white mb-2"
          @click="confirmarUsuario()"
          v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            <span
              class="spinner-border spinner-border-sm align-middle ms-1"
            ></span>
            Aguarde...
          </span>
          <span class="svg-icon svg-icon-1" v-if="!this.loading">
            <inline-svg
              src="media/icons/duotune/arrows/arr016.svg"
              class="me-2"
            />Confirmar
          </span>
        </button>
      </div>
    </div>
  </div>
  <CidadesModal
    v-if="exibirCidades"
    @exibirModalCidades="modalCidades"
    @confirmarCidade="confirmarCidade"
  ></CidadesModal>
  <PaisesModal
    v-if="exibirPaises"
    @exibirModalPaises="modalPaises"
    @confirmarPais="confirmarPais"
  ></PaisesModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import CidadesModal from "@/views/cidades/CidadesModal.vue";
import PaisesModal from "@/views/paises/PaisesModal";
import { useToast } from "vue-toastification";
const toast = useToast();
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
const usuarioMapper = {
  UsuarioEnderecoCep: ["", ""],
};

var usuarioInicial = {
  nome: "",
  usuario: "",
  senha: "",
  ativo: true,
  guid: "",
  id_tipo_usuario: 4,
  id_emitente_tipo_usuario: 0,
  id_software_house: 0,
  id_empresa: 0,
  assistente_boas_vindas: true,
  UsuarioDado: {
    id: 0,
    id_usuario: 0,
    cpf_cnpj: "",
    tipo: "F",
    rg_ie: "",
    contato: "",
    foto: "",
    formFile: null,
    fotoRemover: "",
  },
  UsuarioEndereco: [
    {
      id: 0,
      id_usuario: 0,
      descricao: "Casa",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
    },
  ],
  UsuarioTelefone: [
    {
      id: 0,
      id_usuario: 0,
      descricao: "Celular",
      telefone: "",
    },
  ],
};

export default {
  components: {
    CidadesModal,
    PaisesModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async desativarUsuario() {
      this.errosGeraisDesativar = {};
      this.errosValidacaoDesativar = "";
      if (this.desativar === false) {
        this.errosValidacaoDesativar = "* Confirme para desativar";
      } else {
        this.usuario.ativo = false;
        this.loadingDesativar = true;
        await this.atualizarUsuario();
      }
    },
    async atualizarUsuario() {
      this.usuario.ativo = this.$utils.booleanToString(this.usuario.ativo);
      this.usuario.assistente_boas_vindas = this.$utils.booleanToString(
        this.usuario.assistente_boas_vindas
      );

      try {
        var ret = await this.$store.dispatch(
          "usuario/putUsuario",
          this.usuario
        );
        if (ret.Success === true) {
          if (this.loadingDesativar === true) {
            this.$router.push("/configuracoes/usuarios/consultar");
            toast.success("Usuário desativado com sucesso!", { timeout: 3000 });
          } else {
            toast.success("Perfil salvo com sucesso!", { timeout: 3000 });
          }
          usuarioInicial = JSON.parse(JSON.stringify(this.usuario));
        }
      } catch (error) {
        if (this.loadingDesativar === true) {
          this.errosGeraisDesativar = error;
          this.scroll("usuario_desativar");
        }
        if (this.loadingPerfil === true) {
          this.errosGeraisPerfil = error;
          this.errosValidacaoPerfil = error;
          this.errosValidacao = error;
          this.scroll("usuario_perfil");
        }
        this.errosValidacaoGeral.push(
          ...this.$utils.retornarValoresJson(error)
        );
      }
      this.usuario.ativo = this.$utils.stringToBoolean(this.usuario.ativo);
      this.usuario.assistente_boas_vindas = this.$utils.stringToBoolean(
        this.usuario.assistente_boas_vindas
      );

      this.loadingDesativar = false;
      this.loadingPerfil = false;
    },
    exibirEmail() {
      this.emailExibir = true;
      this.limparSenha();
    },
    exibirSenha() {
      this.senhaExibir = true;
      this.limparEmail();
    },
    limparEmail() {
      this.emailExibir = false;
      this.usuario.usuario = usuarioInicial.usuario;
      this.senhaAtual = "";
      this.errosGeraisMetodoLogin = {};
      this.errosValidacaoMetodoLogin = [];
    },
    limparSenha() {
      this.senhaExibir = false;
      this.senhaAtual = "";
      this.novaSenha = "";
      this.confirmarNovaSenha = "";
      this.errosGeraisMetodoLogin = {};
      this.errosValidacaoMetodoLogin = [];
    },
    async confirmarEmail() {
      this.errosGeraisMetodoLogin = {};
      this.errosValidacaoMetodoLogin = [];
      var atualizar = true;
      if (this.usuario.usuario.trim() === "") {
        Object.assign(this.errosValidacaoMetodoLogin, {
          usuario: "O email não pode ser vazio",
        });
        atualizar = false;
      }
      if (this.senhaAtual.trim() === "") {
        Object.assign(this.errosValidacaoMetodoLogin, {
          senhaAtual: "A senha atual não pode ser vazia",
        });
        atualizar = false;
      }
      if (atualizar === true) {
        this.loadingMetodoLogin = true;

        var emailViewModel = {
          LoginAtual: usuarioInicial.usuario,
          NovoLogin: this.usuario.usuario,
          SenhaAtual: this.senhaAtual,
        };

        try {
          var ret = await this.$store.dispatch(
            "usuario/putAlterarEmailUsuario",
            emailViewModel
          );
          if (ret.Success === true) {
            this.emailExibir = false;
            this.senhaAtual = "";
            toast.success("Email salvo com sucesso!", { timeout: 3000 });
            usuarioInicial = JSON.parse(JSON.stringify(this.usuario));
          }
        } catch (error) {
          this.errosGeraisMetodoLogin = error;
          this.errosValidacaoMetodoLogin = error;
          this.scroll("usuario_metodo_login");
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
        }
        this.loadingMetodoLogin = false;
      }
    },
    async confirmarSenha() {
      this.errosGeraisMetodoLogin = {};
      this.errosValidacaoMetodoLogin = [];
      var atualizar = true;
      if (this.senhaAtual.trim() === "") {
        Object.assign(this.errosValidacaoMetodoLogin, {
          senhaAtual: "A senha atual não pode ser vazia",
        });
        atualizar = false;
      }
      if (this.novaSenha.trim() === "") {
        Object.assign(this.errosValidacaoMetodoLogin, {
          novaSenha: "A nova senha não pode ser vazia",
        });
        atualizar = false;
      }
      if (this.confirmarNovaSenha.trim() === "") {
        Object.assign(this.errosValidacaoMetodoLogin, {
          confirmarNovaSenha: "A confirmação da senha não pode ser vazia",
        });
        atualizar = false;
      } else if (this.novaSenha !== this.confirmarNovaSenha) {
        Object.assign(this.errosValidacaoMetodoLogin, {
          confirmarNovaSenha: "As senhas não conferem",
        });
        atualizar = false;
      }
      if (atualizar === true) {
        this.loadingMetodoLogin = true;

        var senhaViewModel = {
          Login: this.usuario.usuario,
          SenhaAtual: this.senhaAtual,
          NovaSenha: this.novaSenha,
        };

        try {
          var ret = await this.$store.dispatch(
            "usuario/putAlterarSenhaUsuario",
            senhaViewModel
          );
          if (ret.Success === true) {
            this.senhaExibir = false;
            this.senhaAtual = "";
            this.novaSenha = "";
            this.confirmarNovaSenha = "";
            toast.success("Senha salva com sucesso!", { timeout: 3000 });
          }
        } catch (error) {
          this.errosGeraisMetodoLogin = error;
          this.errosValidacaoMetodoLogin = error;
          this.scroll("usuario_metodo_login");
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
        }
        this.loadingMetodoLogin = false;
      }
    },
    modalCidades(exibir) {
      this.exibirCidades = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cidades",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCidades");
          },
          /*close*/ () => {
            this.modalCidades(false);
          }
        );
      }
    },
    exibirModalCidades(exibir, index) {
      this.pesquisaCidadeIndex = index;
      this.modalCidades(exibir);
    },
    confirmarCidade(cidade) {
      this.usuario.UsuarioEndereco[this.pesquisaCidadeIndex].cidade =
        cidade.cidade;
      this.usuario.UsuarioEndereco[this.pesquisaCidadeIndex].cod_cidade =
        cidade.codcidade;
      this.usuario.UsuarioEndereco[this.pesquisaCidadeIndex].uf = cidade.uf;
      this.usuario.UsuarioEndereco[this.pesquisaCidadeIndex].cod_pais = "1058";
      this.usuario.UsuarioEndereco[this.pesquisaCidadeIndex].pais = "BRASIL";
    },
    modalPaises(exibir) {
      this.exibirPaises = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_paises",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPaises");
          },
          /*close*/ () => {
            this.modalPaises(false);
          }
        );
      }
    },
    exibirModalPaises(exibir, index) {
      this.pesquisaPaisIndex = index;
      this.modalPaises(exibir);
    },
    confirmarPais(pais) {
      this.usuario.UsuarioEndereco[this.pesquisaPaisIndex].cod_pais =
        pais.codbacen;
      this.usuario.UsuarioEndereco[this.pesquisaPaisIndex].pais =
        pais.descricao;
    },
    async pesquisarCep(i) {
      this.loadingCep = true;
      if (
        this.usuario.UsuarioEndereco[i].cep !== null &&
        this.usuario.UsuarioEndereco[i].cep != ""
      ) {
        try {
          var ret = await this.$store.dispatch(
            "cep/getCep",
            this.usuario.UsuarioEndereco[i].cep
          );
          if (ret.Data !== null) {
            this.usuario.UsuarioEndereco[i].endereco = ret.Data.logradouro;
            this.usuario.UsuarioEndereco[i].bairro = ret.Data.bairro;
            this.usuario.UsuarioEndereco[i].complemento = ret.Data.complemento;
            this.usuario.UsuarioEndereco[i].cod_cidade = ret.Data.ibge;
            this.usuario.UsuarioEndereco[i].cidade = ret.Data.localidade
              ? ret.Data.localidade.toUpperCase()
              : "";
            this.usuario.UsuarioEndereco[i].uf = ret.Data.uf;
            this.usuario.UsuarioEndereco[i].pais = "BRASIL";
            this.usuario.UsuarioEndereco[i].cod_pais = "1058";
          }
        } catch (error) {
          await this.$swal.showInvalidAlert(
            "Não foi possível localizar o CEP!"
          );
        }
      }
      this.loadingCep = false;
    },
    adicionarEndereco() {
      this.usuario.UsuarioEndereco.push({
        id: 0,
        id_usuario: 0,
        descricao: "Casa",
        endereco: "",
        complemento: "",
        bairro: "",
        numero: "",
        cep: "",
        cidade: "",
        cod_cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
        latitude: "",
        longitude: "",
      });
    },
    async excluirEndereco(index) {
      if (this.usuario.UsuarioEndereco.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGeraisEndereco = {};
              this.errosValidacaoEndereco = [];
              this.loadingEndereco = true;

              var id = this.usuario.UsuarioEndereco[index].id;
              if (id === 0) {
                this.usuario.UsuarioEndereco.splice(index, 1);
                toast.success("Endereço excluído com sucesso!", {
                  timeout: 3000,
                });
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "usuarioEndereco/deleteUsuarioEndereco",
                    id
                  );
                  if (ret.Success === true) {
                    this.usuario.UsuarioEndereco.splice(index, 1);

                    for (
                      var i = 0;
                      i < usuarioInicial.UsuarioEndereco.length;
                      i++
                    ) {
                      if (usuarioInicial.UsuarioEndereco[i].id === id) {
                        usuarioInicial.UsuarioEndereco.splice(i, 1);
                      }
                    }

                    toast.success("Endereço excluído com sucesso!", {
                      timeout: 3000,
                    });
                  }
                } catch (error) {
                  this.errosGeraisEndereco = error;
                  this.scroll("usuario_endereco");
                }
              }
              this.loadingEndereco = false;
            }
          }
        );
      }
    },
    limparEndereco() {
      this.usuario.UsuarioEndereco = JSON.parse(
        JSON.stringify(usuarioInicial.UsuarioEndereco)
      );
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
    },
    async confirmarEndereco() {
      var confirmouEndereco = true;
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = new Array(
        this.usuario.UsuarioEndereco.length
      );
      this.loadingEndereco = true;

      for (var i = 0; i < this.usuario.UsuarioEndereco.length; i++) {
        this.usuario.UsuarioEndereco[i].complemento =
          this.usuario.UsuarioEndereco[i].complemento === ""
            ? null
            : this.usuario.UsuarioEndereco[i].complemento;

        this.usuario.UsuarioEndereco[i].latitude =
          this.usuario.UsuarioEndereco[i].latitude === ""
            ? null
            : this.usuario.UsuarioEndereco[i].latitude;

        this.usuario.UsuarioEndereco[i].longitude =
          this.usuario.UsuarioEndereco[i].longitude === ""
            ? null
            : this.usuario.UsuarioEndereco[i].longitude;

        if (this.usuario.UsuarioEndereco[i].id === 0) {
          this.usuario.UsuarioEndereco[i].id_usuario = this.usuario.id;
          try {
            var retPost = await this.$store.dispatch(
              "usuarioEndereco/postUsuarioEndereco",
              this.usuario.UsuarioEndereco[i]
            );
            if (retPost.Success === true) {
              this.usuario.UsuarioEndereco[i].id = retPost.Data.id;
              usuarioInicial.UsuarioEndereco.push(
                JSON.parse(JSON.stringify(this.usuario.UsuarioEndereco[i]))
              );
            }
          } catch (error) {
            confirmouEndereco = false;
            this.errosGeraisEndereco = error;
            this.errosValidacaoEndereco[i] = error;
            this.scroll("usuario_endereco");
          }
        } else {
          try {
            var retPut = await this.$store.dispatch(
              "usuarioEndereco/putUsuarioEndereco",
              this.usuario.UsuarioEndereco[i]
            );
            if (retPut.Success === true) {
              for (var y = 0; y < usuarioInicial.UsuarioEndereco.length; y++) {
                if (usuarioInicial.UsuarioEndereco[y].id === retPut.Data.id) {
                  usuarioInicial.UsuarioEndereco[y] = JSON.parse(
                    JSON.stringify(this.usuario.UsuarioEndereco[i])
                  );
                }
              }
            }
          } catch (error) {
            confirmouEndereco = false;
            this.errosGeraisEndereco = error;
            this.errosValidacaoEndereco[i] = error;
            this.scroll("usuario_endereco");
          }
        }
      }
      if (confirmouEndereco === true) {
        toast.success("Endereços salvos com sucesso!", { timeout: 3000 });
      }
      this.loadingEndereco = false;
    },
    adicionarTelefone() {
      this.usuario.UsuarioTelefone.push({
        id: 0,
        id_usuario: 0,
        descricao: "Celular",
        telefone: "",
      });
    },
    async excluirTelefone(index) {
      if (this.usuario.UsuarioTelefone.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGeraisTelefone = {};
              this.errosValidacaoTelefone = [];
              this.loadingTelefone = true;

              var id = this.usuario.UsuarioTelefone[index].id;
              if (id === 0) {
                this.usuario.UsuarioTelefone.splice(index, 1);
                toast.success("Telefone excluído com sucesso!", {
                  timeout: 3000,
                });
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "usuarioTelefone/deleteUsuarioTelefone",
                    id
                  );
                  if (ret.Success === true) {
                    this.usuario.UsuarioTelefone.splice(index, 1);
                    for (
                      var i = 0;
                      i < usuarioInicial.UsuarioTelefone.length;
                      i++
                    ) {
                      if (usuarioInicial.UsuarioTelefone[i].id === id) {
                        usuarioInicial.UsuarioTelefone.splice(i, 1);
                      }
                    }
                    toast.success("Telefone excluído com sucesso!", {
                      timeout: 3000,
                    });
                  }
                } catch (error) {
                  this.errosGeraisTelefone = error;
                  this.scroll("usuario_telefone");
                }
              }
              this.loadingTelefone = false;
            }
          }
        );
      }
    },
    limparTelefone() {
      this.usuario.UsuarioTelefone = JSON.parse(
        JSON.stringify(usuarioInicial.UsuarioTelefone)
      );
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
    },
    async confirmarTelefone() {
      var confirmouTelefone = true;
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = new Array(
        this.usuario.UsuarioTelefone.length
      );
      this.loadingTelefone = true;

      for (var i = 0; i < this.usuario.UsuarioTelefone.length; i++) {
        if (this.usuario.UsuarioTelefone[i].id === 0) {
          this.usuario.UsuarioTelefone[i].id_usuario = this.usuario.id;
          try {
            var retPost = await this.$store.dispatch(
              "usuarioTelefone/postUsuarioTelefone",
              this.usuario.UsuarioTelefone[i]
            );
            if (retPost.Success === true) {
              this.usuario.UsuarioTelefone[i].id = retPost.Data.id;
              usuarioInicial.UsuarioTelefone.push(
                JSON.parse(JSON.stringify(this.usuario.UsuarioTelefone[i]))
              );
            }
          } catch (error) {
            confirmouTelefone = false;
            this.errosGeraisTelefone = error;
            this.errosValidacaoTelefone[i] = error;
            this.scroll("usuario_telefone");
          }
        } else {
          try {
            var retPut = await this.$store.dispatch(
              "usuarioTelefone/putUsuarioTelefone",
              this.usuario.UsuarioTelefone[i]
            );
            if (retPut.Success === true) {
              for (var y = 0; y < usuarioInicial.UsuarioTelefone.length; y++) {
                if (usuarioInicial.UsuarioTelefone[y].id === retPut.Data.id) {
                  usuarioInicial.UsuarioTelefone[y] = JSON.parse(
                    JSON.stringify(this.usuario.UsuarioTelefone[i])
                  );
                }
              }
            }
          } catch (error) {
            confirmouTelefone = false;
            this.errosGeraisTelefone = error;
            this.errosValidacaoTelefone[i] = error;
            this.scroll("usuario_telefone");
          }
        }
      }
      if (confirmouTelefone === true) {
        toast.success("Telefones salvos com sucesso!", { timeout: 3000 });
      }

      this.loadingTelefone = false;
    },
    limparPerfil() {
      this.usuario.UsuarioDado = JSON.parse(
        JSON.stringify(usuarioInicial.UsuarioDado)
      );
      this.usuario.nome = usuarioInicial.nome;
      this.usuario.id_tipo_usuario = usuarioInicial.id_tipo_usuario;
      this.errosGeraisPerfil = {};
      this.errosValidacaoPerfil = [];
    },
    async confirmarPerfil() {
      this.errosGeraisPerfil = {};
      this.errosValidacaoPerfil = [];
      this.errosValidacaoGeral = [];
      this.loadingPerfil = true;

      this.usuario.UsuarioDado.foto =
        this.usuario.UsuarioDado.foto === null
          ? ""
          : this.usuario.UsuarioDado.foto.replace(this.$utils.getUrl(), "");
      this.usuario.UsuarioDado.rg_ie =
        this.usuario.UsuarioDado.rg_ie === null
          ? ""
          : this.usuario.UsuarioDado.rg_ie;
      this.usuario.UsuarioDado.contato =
        this.usuario.UsuarioDado.contato === null
          ? ""
          : this.usuario.UsuarioDado.contato;

      if (this.usuario.UsuarioDado.id === 0) {
        this.usuario.UsuarioDado.id_usuario = this.usuario.id;
      }

      var formData = this.$utils.convertModelToFormData(
        this.usuario.UsuarioDado
      );

      if (this.usuario.UsuarioDado.id === 0) {
        try {
          var retPost = await this.$store.dispatch(
            "usuarioDado/postUsuarioDado",
            formData
          );
          if (retPost.Success === true) {
            this.usuario.UsuarioDado.id = retPost.Data.id;
            this.usuario.UsuarioDado.foto = retPost.Data.foto;

            this.usuario.UsuarioDado.formFile = null;

            usuarioInicial.UsuarioDado = JSON.parse(
              JSON.stringify(this.usuario.UsuarioDado)
            );
            await this.atualizarUsuario();
          }
        } catch (error) {
          this.errosGeraisPerfil = error;
          this.errosValidacaoPerfil = error;
          this.errosValidacao = error;
          this.scroll("usuario_perfil");
        }
      } else {
        try {
          var retPut = await this.$store.dispatch(
            "usuarioDado/putUsuarioDado",
            formData
          );
          if (retPut.Success === true) {
            this.usuario.UsuarioDado.foto = retPut.Data.foto;

            this.usuario.UsuarioDado.formFile = null;

            usuarioInicial.UsuarioDado = JSON.parse(
              JSON.stringify(this.usuario.UsuarioDado)
            );
            await this.atualizarUsuario();
          }
        } catch (error) {
          this.errosGeraisPerfil = error;
          this.errosValidacaoPerfil = error;
          this.errosValidacao = error;
          this.scroll("usuario_perfil");
        }
      }
      if (
        this.usuario.UsuarioDado.foto !== "" &&
        this.usuario.UsuarioDado.foto !== null &&
        !this.usuario.UsuarioDado.foto.includes("base64")
      ) {
        this.usuario.UsuarioDado.foto =
          this.$utils.getUrl() + this.usuario.UsuarioDado.foto;
      }
      this.loadingPerfil = false;
    },
    async confirmarUsuario() {
      this.errosValidacaoGeral = [];
      this.loading = true;
      this.usuario.ativo = this.$utils.booleanToString(this.usuario.ativo);
      this.usuario.assistente_boas_vindas = this.$utils.booleanToString(
        this.usuario.assistente_boas_vindas
      );
      this.usuario.UsuarioDado.foto =
        this.usuario.UsuarioDado.foto === null
          ? ""
          : this.usuario.UsuarioDado.foto.replace(this.$utils.getUrl(), "");
      this.usuario.UsuarioDado.rg_ie =
        this.usuario.UsuarioDado.rg_ie === null
          ? ""
          : this.usuario.UsuarioDado.rg_ie;
      this.usuario.UsuarioDado.contato =
        this.usuario.UsuarioDado.contato === null
          ? ""
          : this.usuario.UsuarioDado.contato;

      for (var i = 0; i < this.usuario.UsuarioEndereco.length; i++) {
        this.usuario.UsuarioEndereco[i].complemento =
          this.usuario.UsuarioEndereco[i].complemento === null
            ? ""
            : this.usuario.UsuarioEndereco[i].complemento;

        this.usuario.UsuarioEndereco[i].latitude =
          this.usuario.UsuarioEndereco[i].latitude === null
            ? ""
            : this.usuario.UsuarioEndereco[i].latitude;

        this.usuario.UsuarioEndereco[i].longitude =
          this.usuario.UsuarioEndereco[i].longitude === null
            ? ""
            : this.usuario.UsuarioEndereco[i].longitude;
      }

      this.usuario.guid = this.$utils.generateUuidv4();

      this.usuario.id_empresa = this.user.User.id_empresa;
      this.usuario.id_software_house = this.user.User.id_software_house;

      var tempformData = JSON.parse(JSON.stringify(this.usuario));

      if (
        this.$utils.isEquivalent(
          this.usuario.UsuarioDado,
          usuarioInicial.UsuarioDado
        ) === true
      ) {
        tempformData.UsuarioDado = null;
      }

      if (
        this.$utils.isEquivalent(
          this.usuario.UsuarioEndereco[0],
          usuarioInicial.UsuarioEndereco[0]
        ) === true &&
        this.usuario.UsuarioEndereco.length ===
          usuarioInicial.UsuarioEndereco.length
      ) {
        tempformData.UsuarioEndereco = [];
      }

      if (
        this.$utils.isEquivalent(
          this.usuario.UsuarioTelefone[0],
          usuarioInicial.UsuarioTelefone[0]
        ) === true &&
        this.usuario.UsuarioTelefone.length ===
          usuarioInicial.UsuarioTelefone.length
      ) {
        tempformData.UsuarioTelefone = [];
      }

      var formData = this.$utils.convertModelToFormData(tempformData);

      try {
        var ret = await this.$store.dispatch("usuario/postUsuario", formData);
        if (ret.Success === true) {
          this.$router.push("/configuracoes/usuarios/consultar");
          toast.success("Cadastro salvo com sucesso!", { timeout: 3000 });
        }
      } catch (error) {
        this.errosGerais = error;
        this.errosValidacao = error;
        this.errosValidacaoPerfil.push(
          ...this.$utils.retornarValoresJsonAtalho(error, usuarioMapper)
        );
      }
      this.usuario.ativo = this.$utils.stringToBoolean(this.usuario.ativo);
      this.usuario.assistente_boas_vindas = this.$utils.stringToBoolean(
        this.usuario.assistente_boas_vindas
      );
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    limparUsuario() {
      this.usuario = {
        nome: "",
        usuario: "",
        senha: "",
        ativo: true,
        guid: "",
        id_tipo_usuario: 4,
        id_emitente_tipo_usuario: 0,
        id_software_house: 0,
        id_empresa: 0,
        assistente_boas_vindas: true,
        UsuarioDado: {
          id: 0,
          id_usuario: 0,
          cpf_cnpj: "",
          tipo: "F",
          rg_ie: "",
          contato: "",
          foto: "",
          formFile: null,
          fotoRemover: "",
        },
        UsuarioEndereco: [
          {
            id: 0,
            id_usuario: 0,
            descricao: "Casa",
            endereco: "",
            complemento: "",
            bairro: "",
            numero: "",
            cep: "",
            cidade: "",
            cod_cidade: "",
            uf: "SP",
            pais: "",
            cod_pais: "",
            latitude: "",
            longitude: "",
          },
        ],
        UsuarioTelefone: [
          {
            id: 0,
            id_usuario: 0,
            descricao: "Celular",
            telefone: "",
          },
        ],
      };
      usuarioInicial = JSON.parse(JSON.stringify(this.usuario));

      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosGeraisPerfil = {};
      this.errosValidacaoPerfil = [];
      this.errosGeraisTelefone = {};
      this.errosValidacaoTelefone = [];
      this.errosGeraisEndereco = {};
      this.errosValidacaoEndereco = [];
      this.errosGeraisMetodoLogin = {};
      this.errosValidacaoMetodoLogin = [];
      this.errosGeraisDesativar = {};
      this.errosValidacaoDesativar = "";
    },
    removerFoto() {
      if (this.add === true) {
        this.usuario.UsuarioDado.fotoRemover = "";
      } else {
        this.usuario.UsuarioDado.fotoRemover =
          this.usuario.UsuarioDado.foto.replace(this.$utils.getUrl(), "");
      }
      this.usuario.UsuarioDado.foto = "";
      this.usuario.UsuarioDado.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.usuario.UsuarioDado.foto !== null) {
            this.usuario.UsuarioDado.fotoRemover =
              this.usuario.UsuarioDado.foto.replace(this.$utils.getUrl(), "");
          }

          this.usuario.UsuarioDado.foto = e.target.result;
          this.usuario.UsuarioDado.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarUsuario() {
      var id = this.$route.params.id;
      try {
        var ret = await this.$store.dispatch(
          "usuario/getUsuarioOData",
          "?$select=id,nome,usuario,ativo,guid,id_tipo_usuario,id_software_house,id_empresa,id_emitente_tipo_usuario,assistente_boas_vindas&$expand=UsuarioDado,UsuarioTelefone,UsuarioEndereco,SoftwareHouse,Emitente" +
            "&$filter=id eq " +
            id
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.usuario = ret.value[0];
          this.usuario.ativo = this.$utils.stringToBoolean(this.usuario.ativo);
          this.usuario.assistente_boas_vindas = this.$utils.stringToBoolean(
            this.usuario.assistente_boas_vindas
          );

          if (this.usuario.UsuarioDado === null) {
            this.usuario.UsuarioDado = JSON.parse(
              JSON.stringify(usuarioInicial.UsuarioDado)
            );
          }

          if (this.usuario.UsuarioEndereco.length === 0) {
            this.usuario.UsuarioEndereco = JSON.parse(
              JSON.stringify(usuarioInicial.UsuarioEndereco)
            );
          }

          if (this.usuario.UsuarioTelefone.length === 0) {
            this.usuario.UsuarioTelefone = JSON.parse(
              JSON.stringify(usuarioInicial.UsuarioTelefone)
            );
          }

          if (
            this.usuario.UsuarioDado.foto !== null &&
            this.usuario.UsuarioDado.foto !== ""
          ) {
            this.usuario.UsuarioDado.foto =
              this.$utils.getUrl() + this.usuario.UsuarioDado.foto;
          }

          usuarioInicial = JSON.parse(JSON.stringify(this.usuario));
        } else {
          this.errosGerais = {
            message: "Nenhum usuário foi encontrado com o ID informado!",
          };
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async carregarTipoUsuario() {
      try {
        var ret = await this.$store.dispatch(
          "tipoUsuario/getTipoUsuarioOData",
          "?$select=id,tipo"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tiposUsuarios = ret.value;
          this.usuario.id_tipo_usuario = ret.value[0].id;
        } else {
          this.errosGeraisPerfil = {
            message: "Nenhum tipo de usuário foi encontrado!",
          };
        }
      } catch (error) {
        this.errosGeraisPerfil = error;
      }
      if (this.errosGeraisPerfil.Message) {
        this.scroll("usuario_perfil");
      }
    },
    async carregarEmitenteTipoUsuario() {
      try {
        var ret = await this.$store.dispatch(
          "emitenteTipoUsuario/getEmitenteTipoUsuarioOData",
          "?$select=id,tipo"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.emitenteTiposUsuarios = ret.value;
          this.usuario.id_emitente_tipo_usuario = ret.value[0].id;
        } else {
          this.errosGeraisPerfil = {
            message: "Nenhum tipo de usuário foi encontrado!",
          };
        }
      } catch (error) {
        this.errosGeraisPerfil = error;
      }
      if (this.errosGeraisPerfil.Message) {
        this.scroll("usuario_perfil");
      }
      this.loadingPerfil = false;
    },
    async asyncData() {
      this.pesquisaCidadeIndex = 0;
      this.pesquisaPaisIndex = 0;
      this.loadingPerfil = true;
      await this.carregarTipoUsuario();
      await this.carregarEmitenteTipoUsuario();

      if (this.$route.params.id !== undefined) {
        this.loading = true;
        this.add = false;
        await this.carregarUsuario();
      } else {
        this.add = true;
        this.limparUsuario();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.UsuarioTelefone.Consultar") {
            this.consultarUsuarioTelefone = true;
          }
          if (element.regra === "Permitir.UsuarioTelefone.Incluir") {
            this.adicionarUsuarioTelefone = true;
          }
          if (element.regra === "Permitir.UsuarioTelefone.Alterar") {
            this.editarUsuarioTelefone = true;
          }
          if (element.regra === "Permitir.UsuarioTelefone.Excluir") {
            this.excluirUsuarioTelefone = true;
          }

          if (element.regra === "Permitir.UsuarioEndereco.Consultar") {
            this.consultarUsuarioEndereco = true;
          }
          if (element.regra === "Permitir.UsuarioEndereco.Incluir") {
            this.adicionarUsuarioEndereco = true;
          }
          if (element.regra === "Permitir.UsuarioEndereco.Alterar") {
            this.editarUsuarioEndereco = true;
          }
          if (element.regra === "Permitir.UsuarioEndereco.Excluir") {
            this.excluirUsuarioEndereco = true;
          }
        });

        //this.idEmpresa = this.user.User.id_empresa;
        //this.tableData.filterOData = "&$filter=id_empresa eq " + this.idEmpresa;
      }
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    await this.asyncData();
    //console.log(this.user);
  },
  data() {
    return {
      consultarUsuarioTelefone: false,
      adicionarUsuarioTelefone: false,
      editarUsuarioTelefone: false,
      excluirUsuarioTelefone: false,
      consultarUsuarioEndereco: false,
      adicionarUsuarioEndereco: false,
      editarUsuarioEndereco: false,
      excluirUsuarioEndereco: false,
      loading: false,
      loadinLogin: false,
      loadingPerfil: false,
      loadingTelefone: false,
      loadingEndereco: false,
      loadingDesativar: false,
      loadingMetodoLogin: false,
      emailExibir: false,
      senhaExibir: false,
      loadingCep: false,
      add: false,
      pesquisaCidadeIndex: 0,
      pesquisaPaisIndex: 0,
      errosGerais: {},
      errosValidacao: [],
      errosGeraisPerfil: {},
      errosValidacaoPerfil: [],
      errosGeraisTelefone: {},
      errosValidacaoTelefone: [],
      errosGeraisEndereco: {},
      errosValidacaoEndereco: [],
      errosGeraisMetodoLogin: {},
      errosValidacaoMetodoLogin: [],
      errosGeraisDesativar: {},
      errosValidacaoGeral: [],
      errosValidacaoDesativar: "",
      exibirCidades: false,
      cidadeSelecionada: null,
      exibirPaises: false,
      paisSelecionado: null,
      usuario: JSON.parse(JSON.stringify(usuarioInicial)),
      tiposUsuarios: [
        {
          id: 0,
          tipo: "",
        },
      ],
      emitenteTiposUsuarios: [
        {
          id: 0,
          tipo: "",
        },
      ],
      consultaCep: {
        cep: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cod_cidade: "",
        cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
      },
      senhaAtual: "",
      novaSenha: "",
      confirmarNovaSenha: "",
      desativar: false,
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
